"use client";

import { useGoToReturn } from "@hooks/use-go-to-return";
import React, { useCallback } from "react";
import { useRouter } from "next/navigation";
import { useNotificationToasts } from "@features/notifications/notifications-hooks";
import routes from "@features/routes";
import { WorkspaceEditForm } from "@features/workspaces/forms/workspace-edit-form";
import { WorkspaceInputView } from "@features/workspaces/types/workspace";
import { usePostWorkspaceMutation } from "@features/workspaces/workspaces-api";
import { WorkspaceInputViewDefaultValue } from "@features/workspaces/workspaces-consts";

export const WorkspaceCreateController = () => {
  // DEPS
  const { showSuccessAddToast } = useNotificationToasts();
  const router = useRouter();
  const goToReturn = useGoToReturn();

  // DATA
  const [postWorkspace, { isLoading: isCreating }] = usePostWorkspaceMutation();

  // ACTIONS
  const postWorkspaceHandler = useCallback(
    (body: Partial<WorkspaceInputView>) =>
      postWorkspace({ body })
        .then(() => {
          showSuccessAddToast();
        })
        .then(() => {
          if (goToReturn) {
            goToReturn();
          } else router.push(routes.application.pages.dashboard.path());
        }),
    [goToReturn, postWorkspace, router, showSuccessAddToast],
  );

  // RENDERS
  return (
    <WorkspaceEditForm
      mode="create"
      initData={WorkspaceInputViewDefaultValue}
      action={postWorkspaceHandler}
      cancel={goToReturn}
      isLoading={isCreating}
    />
  );
};
